var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',[_c('v-card-title',{staticClass:"body-2 pl-3 pa-1 grey darken-2 white--text"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('v-card-text',{staticClass:"px-1 py-5"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }